export default __webpack_public_path__ + "static/media/emploVacat.ae378ff5.png";